$(document).ready(function () {
    $('.jcs4').jCS4({
        slideWidth: 1960,
        slideHeight: 600
    });

    $('.tab-group > ul > li').click(function() {
        
        var self = $(this);
        var currentActive = self.parent().find('.active');

        var idDeselect = '#'+currentActive.attr('data-id');
        var idSelect = '#'+self.attr('data-id');

        if(idDeselect == idSelect) {
            return false;
        }

        currentActive.removeClass('active');
        $(this).addClass('active');

        $(idSelect).show();
        $(idDeselect).hide();
    });

});